import { RADIUS } from 'src/theme/ui-tokens';

import { CM, TEXT_KEEP_ALL_SX } from 'src/sections/home/constants/home-theme';

// ----------------------------------------------------------------------

/**
 * 블로그 목록·글 상세의 표현 토큰 — **정본은 홈 쪽 한 곳**(`home/constants/home-theme`)이다.
 * 🔑 공개 지면이 같은 색·글자·여백 박자로 서야 한 서비스로 읽힌다. 여기는 블로그만 쓰는 치수를 더한다.
 */
export {
  CM,
  SECTION_PX,
  PUBLIC_TEXT,
  PUBLIC_CTA_SX,
  PUBLIC_MAX_WIDTH,
} from 'src/sections/home/constants/home-theme';

/** 블로그 목록·글 상세의 바탕 — 다른 공개 지면(홈·기능·MCP)과 같은 흰색 · 낱말 단위 줄바꿈을 글자에 전파 */
export const BLOG_PAGE_SX = {
  bgcolor: '#fff',
  minHeight: '100vh',
  width: '100%',
  ...TEXT_KEEP_ALL_SX,
  '& .MuiTypography-root': TEXT_KEEP_ALL_SX,
};

/** 블로그 머리 하이라이트 글 수 — 왼쪽 큰 글 하나 + 오른쪽 작은 글 셋 */
export const BLOG_HIGHLIGHT_COUNT = 4;

/** 글 본문 폭 — 읽기 좋은 한 줄 길이 */
export const BLOG_READ_WIDTH = 720;

/** 글 상세 표지 폭 — 본문보다 한 단 넓다 */
export const BLOG_COVER_WIDTH = 960;

/** 글 카드 격자 — 폰 한 줄 · 태블릿 둘 · 넓은 화면 셋 */
export const BLOG_GRID_SX = {
  display: 'grid',
  columnGap: 3,
  rowGap: { xs: 3, md: 4 },
  gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
} as const;

/** 글 상세 「최근 글」 격자 — 넉 장이 한 줄에 선다(`pickRecentPosts` 가 넷을 고른다) */
export const BLOG_RECENT_GRID_SX = {
  ...BLOG_GRID_SX,
  rowGap: 3,
  gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' },
} as const;

/** 표지 그림의 모서리 — 카드·하이라이트·상세가 같은 값 */
export const BLOG_COVER_RADIUS = RADIUS.md;

/** 표지 틀 — 그림이 늦으면 옅은 면이 자리를 지킨다 · 올리면 커지는 그림을 모서리 안에 가둔다 */
export const BLOG_COVER_FRAME_SX = { overflow: 'hidden', borderRadius: BLOG_COVER_RADIUS, bgcolor: CM.bgMuted } as const;

/** 표지 그림 — 올리면 살짝 커진다(`BLOG_CARD_LINK_SX`) */
export const BLOG_COVER_IMAGE_SX = { '& img': { transition: 'transform 0.3s ease' } } as const;

/** 카드 전체를 덮는 링크 — 올리면 제목(`.blog-card-title`)이 파래지고 표지가 커진다 */
export const BLOG_CARD_LINK_SX = {
  display: 'flex',
  flexDirection: 'column',
  color: 'inherit',
  textDecoration: 'none',
  '& .blog-card-title': { transition: 'color 0.2s' },
  '&:hover .blog-card-title': { color: CM.primary },
  '&:hover img': { transform: 'scale(1.03)' },
} as const;

/** 몇 줄에서 자르는 글 — 넘치면 말줄임 */
export const clampLines = (lines: number | Record<string, number>) =>
  ({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: lines,
    overflow: 'hidden',
  }) as const;
